import { Alert, Box, Snackbar } from "@mui/material";
import { useSnackbarStore } from "../app/store";

export default function SnackbarHandler(props) {
	const { message, severity, clear } = useSnackbarStore();

	return (
		<Snackbar open={!!message} autoHideDuration={severity == 'error' ? 300000 : 5000} onClose={clear}>
			<Alert severity={severity} onClose={clear}>
				{message}
			</Alert>
		</Snackbar>
	);
}
